import { gql } from '@apollo/client';
import { CRM_EMAIL_MESSAGE_FIELDS } from './queries';

export const SEND_CRM_EMAIL = gql`
    mutation SendCrmEmail($input: SendCrmEmailInput!) {
        sendCrmEmail(input: $input) {
            ${CRM_EMAIL_MESSAGE_FIELDS}
        }
    }
`;

/* Save the general Pogozo CRM email signature (POGO-13734). */
export const SAVE_CRM_EMAIL_SETTINGS = gql`
    mutation SaveCrmEmailSettings($input: SaveCrmEmailSettingsInput!) {
        saveCrmEmailSettings(input: $input) {
            signature
        }
    }
`;
